<template>
  <div class="job-list">
    <div v-if="headings" class="job-list__head container-fluid">
      <div class="row">
        <div class="col col-1">
          {{ headings.job_id || "" }}
        </div>
        <!-- <div class="col col-1">
          {{ headings.job_name || "" }}
        </div> -->
        <div class="col col-3">
          {{ headings.location || "" }}
        </div>
        <div class="col col-5">
          <div class="row">
            <div class="col col-7">
              {{ headings.date || "" }}
            </div>
            <div class="col col-5 pl-0">
              {{ headings.technician || "" }}
            </div>
          </div>
        </div>
        <div class="col col-3">
          {{ headings.status || "" }}
        </div>
      </div>
    </div>

    <ul v-if="jobs.length" class="job-list__items list-reset">
      <li
        v-for="(job, index) in jobs"
        :key="index"
        :class="{
          'job-list__item': true,
          selected: job == selected || job.id == selected,
        }"
      >
        <job-list-item
          v-if="job"
          :job="job"
          :icon-src="iconSrc"
          :translations="translations"
          additional-base-class="job-list__job"
          class="job-list__job"
          @date-clicked="onDateClick"
          @planned-clicked="$emit('planned-clicked', $event)"
        >
          <template v-for="(_, name) in $slots">
            <slot v-if="name != 'default'" :name="name" :slot="name" />
          </template>
          <template
            v-for="(_, name) in $scopedSlots"
            :slot="name"
            slot-scope="slotData"
          >
            <slot v-if="name != 'default'" :name="name" v-bind="slotData" />
          </template>
        </job-list-item>
      </li>
    </ul>
    <p v-else-if="!isLoading" class="text-center mt-xl alert alert-warning">
      Keine Montagen gefunden.
    </p>

    <div v-if="!isLoading && isFiltered" class="mt-md text-center">
      <button class="btn btn-small btn-primary" @click="$emit('clear-filter')">
        Filter löschen
      </button>
    </div>
  </div>
</template>

<script>
import NeedsIcons from "../Mixins/NeedsIcons";
import NeedsTranslations from "../Mixins/NeedsTranslations";
import { reduceArrayObjectsMulti } from "../../helpers/common";

export default {
  mixins: [NeedsIcons, NeedsTranslations],
  props: {
    dataUrl: {
      type: String,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    selected: {
      type: Number | Object,
    },
    headings: {
      type: Object,
      default() {
        return null;
      },
    },
    baseLinkUrl: {
      type: String,
    },
    getTechnicianUrl: {
      type: Function,
    },
    managerId: {
      type: Number,
    },
    editDateOnClick: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    isFiltered: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      baseLinkUrl: this.baseLinkUrl,
      managerId: this.managerId,
      getTechnicianUrl: this.getTechnicianUrl,
    };
  },
  watch: {
    data() {
      let dataFilter = this.data && this.data.length ? this.data : [];
      dataFilter= dataFilter.map(x=>{
        let firstdate= true;
        let resultDates = []
        x.dates.map(y=> {
          if(y.technicianRequest){
            if(y.technicianRequest.validUntil > (new Date()) && firstdate){
              resultDates.push(y);
              firstdate =false;
            }
          }
        });
        x['dates_filter'] = resultDates;
          return x;
        });
        this.jobs = dataFilter;
    },
  },
  created() {
    if (this.dataUrl) {
      fetch(this.dataUrl)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          console.log('json',json);
          this.jobs = json;
        });
    }
  },
  updated() {
    const selectedJobElement = this.$el.querySelector(
      ".job-list__item.selected"
    );

    if (selectedJobElement) {
      selectedJobElement.scrollIntoView();
    }
  },
  data() {
    return {
      jobs: this.data,
    };
  },
  methods: {
    onDateClick(dateData) {
      this.$emit("date-clicked", dateData);

      if (this.editDateOnClick) {
        this.$root.showWindow("jobs.job-edit.edit-date", {
          data: { jobDate_id: dateData.id },
          reload: true,
          props: {
            onClose: (win, winData) => {
              if (winData) {
                if ("remove" in winData) {
                  this.$emit("date-removed", winData.remove);
                } else {
                  this.$emit(
                    "date-changed",
                    reduceArrayObjectsMulti(winData, ["start", "end"])
                  );
                }
              }
            },
          },
        });
      }
    },
  },
};
</script>